import { render, staticRenderFns } from "./DocumentRevisionHistory.vue?vue&type=template&id=5801ad3a&scoped=true&"
import script from "./DocumentRevisionHistory.vue?vue&type=script&lang=js&"
export * from "./DocumentRevisionHistory.vue?vue&type=script&lang=js&"
import style0 from "./DocumentRevisionHistory.vue?vue&type=style&index=0&id=5801ad3a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5801ad3a",
  null
  
)

export default component.exports